/**
 * ProviderNoticeBlock — 行内一次性提示块（设计稿 PayerMax A3 / A4）：警示 `--warn-soft`、错误 `--neg-soft`，
 * 标题 + 机读码摘要 + 说明，右侧可放引导按钮；环境级问题加「需要运维处理」标记，与运营自己能补的区分开。
 */

import type { CSSProperties, ReactNode } from 'react';
import { Icons } from '~/lib/icons';
import type { ProviderNotice } from './payment-provider-error-notice';

export function ProviderNoticeBlock({
  notice,
  actions,
  onDismiss,
  style,
}: {
  notice: ProviderNotice;
  actions?: ReactNode;
  onDismiss?: () => void;
  style?: CSSProperties;
}) {
  const neg = notice.tone === 'neg';
  const soft =
    notice.tone === 'neg'
      ? 'var(--neg-soft)'
      : notice.tone === 'info'
        ? 'var(--info-soft)'
        : 'var(--warn-soft)';
  const accent =
    notice.tone === 'neg' ? 'var(--neg)' : notice.tone === 'info' ? 'var(--info)' : 'var(--warn)';
  return (
    <div
      role="alert"
      className="hstack"
      style={{
        gap: 8,
        alignItems: 'flex-start',
        padding: '8px 10px',
        background: soft,
        borderRadius: 'var(--radius)',
        ...style,
      }}
    >
      <Icons.IconAlert size={13} style={{ color: accent, marginTop: 2, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0, fontSize: 11.5, lineHeight: 1.55 }}>
        <span style={{ fontWeight: 500, color: neg ? 'var(--neg)' : undefined }}>
          {notice.title}
        </span>
        {notice.code && (
          <span className="mono" style={{ color: 'var(--fg-muted)' }}>
            {' '}
            · {notice.code}
          </span>
        )}
        {notice.body && (
          <>
            <br />
            <span style={{ color: 'var(--fg-muted)' }}>{notice.body}</span>
          </>
        )}
      </div>
      {actions}
      {onDismiss && (
        <button
          type="button"
          className="btn btn-ghost btn-icon"
          aria-label="关闭提示"
          onClick={onDismiss}
          style={{ width: 22, height: 22 }}
        >
          <Icons.IconX size={11} />
        </button>
      )}
    </div>
  );
}
